import React, { useState, useEffect } from 'react';

import { Stepper, Step, StepLabel, Paper, Typography, MobileStepper, Hidden, Button } from '@material-ui/core';

import EventDetails from './EventDetails';
import EventLocationDetails from './EventLocationDetails';
import ChurchDetails from './ChurchDetails';
import PhoneConfirmationDetails from './PhoneConfirmationDetails';
import CreateInvite from './CreateInvite';
import InviteTemplate from './InviteTemplate';
import ActionsContainer from './ActionsContainer';
import SideInvitePreview from './SideInvitePreview';
import {InvitesProvider} from '../context/InvitesContext';
import {ProviderRequestsProvider} from '../context/ProviderRequestsContext';

import ProviderRequestsForm from './providerRequestsForm/ProviderRequestsForm';

import { useStyles, ColorlibConnector } from './AddEventFormStyles.js';
import './AddEventForm.css';
import { EventsProvider } from '../context/EventsContext';

export default function AddEventForm() {
    const [currentView, setCurrentView] = useState('create-invite');
    const initialStep = Number(localStorage.getItem('activeStep')) || 0;
    const [activeStep, setActiveStep] = useState(initialStep);
    const [phoneConfirmationStepIsValid, setPhoneConfirmationStepIsValid] = useState(true);
    const [showPreviewComponent, setShowPreviewComponent] = useState(false);
    const [inviteTemplateIsSelected, setInviteTemplateIsSelected] = useState(false);

    // Go to next step
    const handleNext = () => {
        setActiveStep(activeStep + 1);
    }

    // Go to previous step
    const handlePrev = () => {
        setActiveStep(activeStep - 1);
    }

    // save active step to local storage
    useEffect( () => {
        localStorage.setItem('activeStep', activeStep);
    })

    const goToProviderRequestsView = () => {
        setCurrentView('provider-requests-view');
      }

    const getStepContent = (step) => {
        switch(step) {
            case 0:
                return (
                    <InviteTemplate 
                        nextStep={handleNext}
                        classes={classes}
                        setInviteTemplateIsSelected={setInviteTemplateIsSelected}
                    />
                )
            case 1:
                return (
                    <EventDetails 
                        nextStep={handleNext}
                        classes={classes}
                    />
                )
            case 2:
                return (
                    <EventLocationDetails 
                        nextStep={handleNext}
                        classes={classes}
                    />
                )
            case 3:
                return (
                    <ChurchDetails 
                        nextStep={handleNext}
                        classes={classes}
                    />
                )
            case 4:
                return (
                    <PhoneConfirmationDetails 
                        nextStep={handleNext}
                        classes={classes}
                        setPhoneConfirmationStepIsValid={setPhoneConfirmationStepIsValid}
                    />
                )
            case 5:
                return (
                    <CreateInvite
                        nextStep={handleNext}
                        classes={classes}
                        activeStep={activeStep}
                        stepsLabel={stepsLabel}
                        handleNext={handleNext}
                        handlePrev={handlePrev}
                        goToProviderRequestsView={goToProviderRequestsView}
                    />
                )
            default:
                break
        }
    }
    const classes = useStyles();
    const stepsLabel = () => {
        let labels = [
            'Alege template',
            'Detalii eveniment',
            'Locație',
            'Biserică',
            'Contact',
            'Descarcă'
        ]
        return labels;
    };
    
    return (
        <div className={classes.root}>
            <ProviderRequestsProvider>
            {currentView === 'create-invite' && 
            <EventsProvider>
                <InvitesProvider>
                    { showPreviewComponent ? 
                        <SideInvitePreview
                            showPreviewComponent={showPreviewComponent}
                            setShowPreviewComponent={setShowPreviewComponent}
                            classes={classes}
                        /> :
                    <div className={classes.formRoot}>
                        <div className={classes.form + (activeStep == 5 && ' gray-section')}>
                            <Paper square elevation={0}>
                                <Typography className={classes.title}>Creează invitație</Typography>
                            </Paper>
                            <Hidden xsDown>
                                <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}
                                    
                                    connector={<ColorlibConnector />}
                                >
                                    {stepsLabel().map((label) => (
                                        <Step key={label}>
                                            <StepLabel 
                                                classes={{
                                                    alternativeLabel: classes.alternativeLabel
                                                }}
                                                StepIconProps={{
                                                    classes: { 
                                                        root: classes.stepIcon,
                                                        completed: classes.completedIcon,
                                                        active: classes.activeIcon
                                                    }
                                                }}
                                            >
                                                {label}
                                            </StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Hidden>
                            <Hidden mdUp>
                                <div className={classes.mobileContainer}>
                                    <Hidden smUp>
                                        <div className={classes.mobileStepLabel}>
                                            <MobileStepper
                                                steps={stepsLabel().length}
                                                position="static"
                                                variant="text"
                                                activeStep={activeStep}
                                            />
                                            <Typography>{stepsLabel()[activeStep]}</Typography>
                                        </div>
                                    </Hidden>
                                    {/* <Hidden smUp>
                                        {
                                        activeStep !== 5 && (
                                        <Typography className={classes.mobilePreviewMessage} variant="body1">
                                            _
                                        </Typography>
                                        )}
                                    </Hidden> */}
                                    <Hidden mdUp>
                                        { activeStep < stepsLabel().length - 1 && (
                                            <>
                                            {
                                                activeStep === 0 && (
                                                    <Typography className={classes.mobilePreviewMessage} variant="body1">
                                                        Poti oricand sa-ti previzualizezi invitatia apasand <span>Preview</span>.
                                                    </Typography>
                                                )
                                            }
                                            <Button className={classes.mobilePreviewBtn} variant="contained" disabled={!inviteTemplateIsSelected} onClick={() => setShowPreviewComponent(true)}>
                                                Preview
                                            </Button>
                                            </>
                                        )}
                                    </Hidden>
                                </div>
                            </Hidden>
                            {getStepContent(activeStep)}
                            {activeStep !== stepsLabel().length -1 ?
                                <ActionsContainer
                                    activeStep={activeStep}
                                    handleNext={handleNext}
                                    handlePrev={handlePrev}
                                    classes={classes}
                                    phoneConfirmationStepIsValid={phoneConfirmationStepIsValid}
                                /> : ''
                            }
                        </div>
                    </div>
                    }
                    <Hidden smDown>
                        <div className={classes.sidePreview} >
                            <SideInvitePreview  />
                        </div>
                    </Hidden>
                </InvitesProvider>
            </EventsProvider>
            }
            {currentView === 'provider-requests-view' && <ProviderRequestsForm />}
            </ProviderRequestsProvider>
        </div>
    )
}
